module.exports = __webpack_public_path__ + "imgs/flowhub-icon.acc0812330e1d243caacd279cb2a289b.svg";